import {useEffect} from 'react'
import {Outlet, useLocation} from 'react-router-dom'
import {ResponsiveLayoutWrapper} from './components/ResponsiveLayoutWrapper'
import {MenuComponent} from '../assets/ts/components'

const MasterLayout = () => {
  const location = useLocation()

  useEffect(() => {
    setTimeout(() => {
      MenuComponent.reinitialization()
    }, 500)
  }, [location.key])

  return (
    <ResponsiveLayoutWrapper />
  )
}

export {MasterLayout}
